import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AssignManufacturerForm } from 'bom/components';
import { useBomPartsImportContext } from 'bom/states';
import { IAssignManufacturerForm } from 'bom/types';
import { AgGridTable } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { Color } from 'theme/enums';

const Table = () => {
  const [closeSelection, setCloseSelection] = useState(false);
  const [isOpenAssignManufacturer, setIsOpenAssignManufacturer] = useState(false);

  const { t } = useTranslation();
  const { isAlternateVersionEnabled } = useBomPartsImportContext();
  const { selectedRows, updateRows } = useAgGridClientTableContext();

  const selectionActions = () => [
    {
      label: t('buttonLabelAssignSelectedTo'),
      color: Color.PRIMARY,
      onClick: () => setIsOpenAssignManufacturer(true),
    },
    {
      label: t('buttonLabelOmitSelected'),
      color: Color.PRIMARY,
      onClick: onOmitSelected,
    },
  ];

  const onAssignManufacturerSubmit = ({ manufacturer }: IAssignManufacturerForm) => {
    const updatedRows = selectedRows?.map((row) => ({
      ...row,
      assignTo: manufacturer,
      omit: false,
    }));

    updateRows({ update: updatedRows });

    handleOnClose();
  };

  const onOmitSelected = () => {
    const updatedRows = selectedRows?.map((row) => ({
      ...row,
      omit: true,
      assignTo: null,
    }));

    updateRows({ update: updatedRows });

    return true;
  };

  const handleOnClose = () => {
    setIsOpenAssignManufacturer(false);
    setCloseSelection(true);
  };

  return (
    <>
      <AgGridTable
        selectionActions={selectionActions}
        closeSelection={closeSelection}
        setCloseSelection={setCloseSelection}
      />

      <AssignManufacturerForm
        isOpen={isOpenAssignManufacturer}
        onClose={handleOnClose}
        onSubmit={onAssignManufacturerSubmit}
        isAlternateVersionEnabled={isAlternateVersionEnabled}
      />
    </>
  );
};

export default Table;
